import {
  Modal,
  Button,
  ModalProps,
  Form,
  Row,
  Col,
  Input,
  Typography,
} from 'antd';

import { PurchaseGrouped } from '@/core/domain/purchase/Purchase.types';
import SituationFormField from '@/components/Movements/DirectSale/SituationFormField';
import { useIntl } from 'react-intl';
import {
  CompaniesInfiniteSelectField,
  DocumentTypesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import { useEffect } from 'react';
import moment from 'moment';
import PurchaseItemsPurchaseList from '../../PurchaseItemsPurchase/PurchaseItemsPurchaseList';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: () => void;
  purchase?: PurchaseGrouped;
}

const PurchaseGroupingInactivesViewModal = ({
  open,
  onCancel,
  purchase,
}: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm();

  useEffect(() => {
    if (purchase) {
      form.setFieldsValue({
        ...purchase,
        releaseDate: moment(purchase.releaseDate),
      });
    }
  }, [open, purchase]);

  return (
    <Modal
      title={'Visualização da compra'}
      open={open}
      onCancel={onCancel}
      width={1400}
      destroyOnClose
      footer={[
        <Button type="primary" ghost onClick={onCancel}>
          Fechar
        </Button>,
      ]}
    >
      <Form layout="vertical" form={form} name="releasePurchaseGeneral">
        <Row gutter={[16, 9]}>
          <Col span={24} lg={24} md={24}>
            <SituationFormField initialValue={purchase?.situation} />
          </Col>

          <Col span={24} lg={3} xl={2}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchases.releases.form.code',
              })}
              name="code"
            >
              <Input disabled />
            </FloatingFormItem>
          </Col>

          <Col span={24} lg={7} xl={7}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchases.releases.form.company',
              })}
              name="companyId"
            >
              <CompaniesInfiniteSelectField disabled />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={6} lg={4} xl={3}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchases.releases.form.releaseDate',
              })}
              name="releaseDate"
            >
              <InputDate disabled />
            </FloatingFormItem>
          </Col>
          <Col md={8} span={24} lg={6} xl={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchases.releases.form.documentNumber',
              })}
              name="documentNumber"
            >
              <Input disabled />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={24} lg={14} xl={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchases.releases.form.documentType',
              })}
              name="documentTypeId"
            >
              <DocumentTypesInfiniteSelectField disabled />
            </FloatingFormItem>
          </Col>

          {purchase && (
            <Col span={24}>
              <Typography.Title level={4}>Itens da Compra</Typography.Title>

              <PurchaseItemsPurchaseList
                purchaseId={purchase.id}
                purchaseItems={purchase.purchaseItems}
              />
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default PurchaseGroupingInactivesViewModal;
